import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import {GoogleMapsHome365Component} from "./google-maps-home365.component";

@NgModule({
  declarations: [
    GoogleMapsHome365Component
  ],
  exports: [
    GoogleMapsHome365Component
  ],
  imports: [
    CommonModule,
    GoogleMapsModule
  ]
})
export class GoogleMapsHome365Module { }
